/**
 * Аппроксимирует ширину текста на основе количества символов и среднего размера.
 * @param {string} text - Текст для измерения.
 * @param {string} fontSize - Размер шрифта (например, '14px').
 * @returns {number} - Примерная ширина в пикселях.
 */
export const approximateTextWidth = (text, fontSize) => {
  const size = parseFloat(fontSize) || 14;
  // Коэффициенты подбираются экспериментально для Arial
  const avgCharWidthFactor = 0.6;
  return text.length * size * avgCharWidthFactor;
};

/**
 * Разбивает длинную строку на массив строк, чтобы каждая помещалась в maxWidth.
 * Использует аппроксимацию ширины текста.
 * @param {string} text - Входной текст.
 * @param {number} maxWidth - Максимальная ширина строки в пикселях.
 * @param {string} fontSize - Размер шрифта (например, '14px').
 * @returns {string[]} - Массив строк.
 */
export const wrapText = (text, maxWidth, fontSize) => {
  const lines = [];
  let currentLine = '';
  const words = text.split(/\s+/); // Разбиваем по пробелам

  words.forEach(word => {
    // Сначала проверяем, поместится ли одно слово
    if (approximateTextWidth(word, fontSize) > maxWidth) {
      // Если нет, разбиваем слово по буквам (грубый метод)
      if (currentLine) {
        lines.push(currentLine.trim());
        currentLine = '';
      }
      let tempWordLine = '';
      for (let i = 0; i < word.length; i++) {
        const char = word[i];
        if (approximateTextWidth(tempWordLine + char, fontSize) <= maxWidth) {
          tempWordLine += char;
        } else {
          lines.push(tempWordLine);
          tempWordLine = char;
        }
      }
      currentLine = tempWordLine; // Остаток слова переносим
    } else {
      // Слово помещается, проверяем, поместится ли с текущей строкой
      const testLine = currentLine ? `${currentLine} ${word}` : word;
      if (approximateTextWidth(testLine, fontSize) <= maxWidth) {
        currentLine = testLine;
      } else {
        // Не помещается, переносим строку
        lines.push(currentLine.trim());
        currentLine = word;
      }
    }
  });

  if (currentLine) {
    lines.push(currentLine.trim());
  }

  return lines;
};

/**
 * Возвращает правильную форму слова в зависимости от числа.
 * @param {number} count - Число.
 * @param {string[]} forms - Массив из трех форм слова (например, ['паблик', 'паблика', 'пабликов']).
 * @returns {string} - Правильная форма слова.
 */
export const pluralize = (count, forms) => {
  if (!Array.isArray(forms) || forms.length !== 3) {
    console.error('Forms argument must be an array of 3 strings.');
    return ''; // или forms[2] как fallback
  }
  const n = Math.abs(count) % 100;
  const n1 = n % 10;
  if (n > 10 && n < 20) {
    return forms[2];
  }
  if (n1 > 1 && n1 < 5) {
    return forms[1];
  }
  if (n1 === 1) {
    return forms[0];
  }
  return forms[2];
}; 